import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Layout, Typography } from 'antd';
import cn from 'classnames';

import { FooterNav } from 'features/FooterNav';

import styles from './Footer.module.scss';

interface IFooterProps extends HTMLAttributes<HTMLElement> {}

export const Footer: FC<IFooterProps> = ({ className, ...props }) => {
	const { t } = useTranslation();

	return (
		<Layout.Footer {...props} className={cn(className, styles.footer)}>
			<FooterNav className={styles.nav} />
			<Typography.Text type={'secondary'} className={styles.copy}>
				{t('© {{year}} Affilead. Все права защищены.', { year: new Date().getFullYear() })}
			</Typography.Text>
		</Layout.Footer>
	);
};
